import React from 'react';

const Additional = props => {
  const { children } = props;

  return (
    <div className="row center-xs middle-xs qq-element-wrap qq-styled-additional">
      <div className="xs-12">
        <div className="row center-xs middle-xs qq-additional">
          <div className="xs-12">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Additional;
